export default __webpack_public_path__ + "static/media/logoHorizontal.58b8ebcf.png";